import L from "leaflet";

const map = {
  gpsPrecision: 1000,
  maxWidth: 200,
  minZoom: 0,
  maxZoom: 19,
  leafletMap: null,
  init: function (element, mapUrl) {
    const map = L.map(element, {zoomControl: true, zoomSnap: 0.1});
    map.zoomControl.setPosition('topright');

    // Remove leaflet mention from bottom right
    map.attributionControl.setPrefix(false);
    L.control.scale({
      imperial: false,
      maxWidth: this.maxWidth,
    }).addTo(map);

    // Setup Map Layer
    L.tileLayer(mapUrl, {
      minZoom: this.minZoom,
      maxZoom: this.maxZoom,
      attribution: '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
    }).addTo(map);
    
    this.leafletMap = map;
  },
  setView: function (latitude, longitude, zoom) {
    this.leafletMap.setView([latitude, longitude], zoom);
  },
  addLayer: function (position) {
    if (!this.leafletMap) {
      return;
    }
    
    const layer = L.control({
      position: position
    });

    layer.onAdd = function () {
      this._div = L.DomUtil.create('div');
      return this._div;
    };
    layer.addTo(this.leafletMap);

    return layer;
  },
  addLayerGroup: function () {
    if (!this.leafletMap) {
      return;  
    }
    
    const layerGroup = L.layerGroup();
    layerGroup.addTo(this.leafletMap);

    return layerGroup;
  },
  addPolyline: function (color) {
    if (!this.leafletMap) {
      return;  
    }

    const polyline = L.polyline([], {color: color});
    polyline.addTo(map.leafletMap);

    return polyline;
  },
  addMarkerToLayer: function (layer, latitude, longitude, iconHtml, popupHtml) {
    const divSizeX = 40;
    const divSizeY = 54;
    const icon = L.divIcon({
        className: '',
        iconAnchor: [divSizeX, divSizeY],
        popupAnchor: [-divSizeX / 2, -divSizeY + 4],
        html: iconHtml
    });
    const mark = L.marker(
        [
            latitude,
            longitude
        ], {
            icon: icon
        }
    );
    mark.bindPopup(popupHtml);
    layer.addLayer(mark);
    return mark;
  }
}

Object.seal(map);
export default map;
